import { Dispatch } from "redux";
import ReceiptRaffleService from "service/ReceiptRaffle";
import { showMessage } from "utilities/helper";
import { GetManualReceiptRafflePayloadTypes } from "utilities/types/ReceiptRaffle";

export const setModalGetReceiptFormOpen = (value: boolean) => {
  return { type: "SET_MODAL_GET_RECEIPT_FORM", value };
};

export const getManualReceiptRaffle =
  (form: GetManualReceiptRafflePayloadTypes, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await ReceiptRaffleService.getManualReceiptRaffle(payload);

      console.log(data);

      dispatch({ type: "SET_RECEIPT_DATA", value: data.data });

      dispatch({ type: "SET_FORM_LOADING", value: false });
      //   dispatch({ type: "SET_MODAL_GET_RECEIPT_FORM", value: false });

      //   handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

  export const setModalPushReceiptFormOpen = (value: boolean) => {
    return { type: "SET_MODAL_PUSH_RECEIPT_FORM", value };
  };
